import React, { useEffect, useState } from "react";
import DeductionPage from "../../../../../entities/DashboardPage/HRModule/Deductions/DeductionHome";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";
// import { useNavigate } from "react-router-dom";

const Deduction = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = useState(false);
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();
  const [employeeData, setEmployeeData] = useState();
  const [deductionType, setDeductionType] = useState([]);

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getDeductionList("", "", page);
    }
  }, [page, permission])
  
  const getDeductionList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDeduction(text, sort, page);
      if (result?.success) {
        let deductions = result?.data?.deduction || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.deduction?.isView === true;
          const hasEditPermission = permission?.deduction?.isEdit === true;
          
          // If employee has edit permission, show all deductions (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.total);
          } else if (hasViewPermission) {
            // If only view permission, show only own data
            deductions = deductions.filter((ded) => ded?.employee?._id === employeeId || ded?.employee?.userId === employeeId);
            setTotal(deductions.length);
          } else {
            // No view permission, show nothing
            deductions = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.total);
        }
        
        setData(deductions);
        setFilteredData(deductions);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getDeductionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDeductionType();
      if (result?.success) {
        setDeductionType(result?.data?.deductions);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteDeduction(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getDeductionList();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleFilter = (text, sort) => {
    getDeductionList(text || "", sort);
  };
  const handleAddNewDeduction = async (employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleDeduction(employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        setOpen(false);
        getDeductionList();
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };
  const updateDeduction = async (id, employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod) => {
    setLoading(true);
    try {
      const result = await AuthService.handleUpdateDeduction(id, employeeId, type, amount, typeD, salary, desc, fromDate, toDate, paymentMethod);

      if (result?.success) {
        showAlert(result?.message, "success")
        setLoading(false);
        setOpen(false);
        getDeductionList();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);
 
    setLoading(true)
    try {
      const result = await AuthService.deductionDownload();
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type:"application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
 

  return (
    <DeductionPage page={page} getDeductionType={getDeductionType} handleDownload={handleDownload} getDeductionList={getDeductionList} deductionType={deductionType} handleUpdate={updateDeduction} open={open} setOpen={setOpen} total={total} setPage={setPage} data={filteredData.length > 0 ? filteredData : data} handleFilter={handleFilter} handleDelete={handleDelete} handleEmployee={SearchEmployee} loading={loading} employeeData={employeeData} handleAdd={handleAddNewDeduction} permission={permission?.deduction?.isEdit || role === "Admin" || role === "SuperAdmin"} role={role} />
  )

}

export default Deduction;
